<template>
  <div>
    <div class="text-left">
      <div class="section-icon">💖</div>
    </div>

    <!-- block -->
    <div class="block mt-4">
      <h1>What people say about me?</h1>
      <p class="mt-4">
        I've gathered few "reviews" from people I've worked with or are
        otherwise important to me and I appreciate their opinion.
      </p>
    </div>
    <!-- ./ block -->

    <hr />

    <!-- review left -->
    <div class="media block">
      <img src="/img/wife.jpg" class="rounded-circle" height="80" />
      <div class="media-body ml-3">
        <h5 class="mt-0">
          Veronika Krajnc <small class="text-muted">(friend, wife)</small>
        </h5>
        <q>
          He is a simple, funny person. I like him.
        </q>
      </div>
    </div>
    <!-- ./ review left -->

    <!-- review right -->
    <div class="media block text-right">
      <div class="media-body mr-3">
        <h5 class="mt-0">
          Emanuel Krajnc <small class="text-muted">(friend, son)</small>
        </h5>
        <q>
          He likes to help everybody and is always happy. He really enjoys his
          motorcycle.
        </q>
      </div>
      <img src="/img/emanuel.jpg" class="rounded-circle" height="80" />
    </div>
    <!-- ./ review right -->

    <!-- review left -->
    <div class="media block">
      <img src="/img/matijajan.jpg" class="rounded-circle" height="80" />
      <div class="media-body ml-3">
        <h5 class="mt-0">
          Matija Jan Krajnc <small class="text-muted">(friend, son)</small>
        </h5>
        <q>
          He is my friend, and I like to play with him. I love him.
        </q>
      </div>
    </div>
    <!-- ./ review left -->

    <!-- review right -->
    <div class="media block text-right">
      <div class="media-body mr-3">
        <h5 class="mt-0">
          Klemen Fajs
          <small class="text-muted">(friend, former colleague)</small>
        </h5>
        <q>
          Give him an air-tight specifications or let him improvise on a loosely
          defined idea, he delivers. He's just an overall great developer, who
          knows how to get shit done and is fun to be around.
        </q>
      </div>
      <img src="/img/fajs.jpg" class="rounded-circle" height="80" />
    </div>
    <!-- ./ review right -->

    <!-- review left -->
    <div class="media block">
      <img src="/img/tibor.jpg" class="rounded-circle" height="80" />
      <div class="media-body ml-3">
        <h5 class="mt-0">
          Tibor Vovčak
          <small class="text-muted">(friend, former colleague)</small>
        </h5>
        <q>
          If you want a great worker with excellent development skills and a
          strong work ethic, you can do no better than Matic.
        </q>
      </div>
    </div>
    <!-- ./ review left -->

    <!-- review right -->
    <div class="media block text-right">
      <div class="media-body mr-3">
        <h5 class="mt-0">
          Rok Sanda
          <small class="text-muted">(friend, life mentor)</small>
        </h5>
        <q>
          I've yet to find a problem Matic wasn't willing to tackle head-on. CVs
          always say, great at learning new things, and it's usually a throwaway
          line. Not with Matic. He can and will learn to do anything, and do it
          efficiently. He's the real deal.
        </q>
      </div>
      <img src="/img/rok.jpg" class="rounded-circle" height="80" />
    </div>
    <!-- ./ review right -->
  </div>
</template>

<script>
export default {
  name: 'Reviews'
}
</script>

<style></style>
